import React from "react";
import DataTable from "components/common/DataTable/DataTable";
import Svg from "components/common/SVG/Svg";
import BaseModal from "components/common/BaseModal/BaseModal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TenantsManagementTableColumns from "constants/tables/tenantsTableCoulumns";
import useTenantManagement from "hooks/tenant/useTenantManagement";
import TenantFormModal from "components/tenants/TenantFormModal";
import { useTenantForm } from "hooks/tenant/useTenantForm";
import { ITenant } from "components/tenants/types";

const TenantsManagementScreen = () => {
  const {
    tenants,
    createTenant,
    updateTenant,
    handleTenantAction,
    handleConfirmTenantAction,
    modals,
    selectedEntity,
    modalTitle,
    getTenants,
  } = useTenantManagement({
    fetchOnLoad: true,
  });

  const {
    showModal,
    isEditMode,
    formState,
    openCreateModal,
    openEditModal,
    closeModal,
    handleSubmit,
  } = useTenantForm({
    onSave: async tenant => {
      try {
        if (isEditMode) {
          await updateTenant(tenant);
        } else {
          await createTenant(tenant);
        }
      } catch (error) {
        console.error("Error saving tenant:", error);
      }
    },
  });

  const handleDropdownAction = (
    row: ITenant,
    event: React.MouseEvent<HTMLButtonElement>,
    actionKey: string,
  ) => {
    event.preventDefault();
    if (actionKey === "editTenant") {
      openEditModal(row);
    } else {
      handleTenantAction(actionKey, row, event as any);
    }
  };

  const onSort = (key: string) => {
    if (key === "actions") return;
    getTenants(undefined, key);
  };

  return (
    <div className="row">
      <div className="col-12 d-flex flex-row align-items-center justify-content-between mb-4">
        <h4 className="mb-0 me-3">Manage Tenants</h4>
        <button
          type="button"
          title="Create Tenant"
          className="btn btn-sm btn-success"
          onClick={openCreateModal}
        >
          <Svg icon="create" width={15} height={15} color="#ffffff" />
          <span className="ms-2">Create</span>
        </button>
      </div>

      <div className="col-12 mx-auto mb-5">
        <div className="card shadow-lg">
          <DataTable
            onSort={onSort}
            tableData={tenants}
            tableColumns={TenantsManagementTableColumns({ handleDropdownAction })}
            tableClassName="table-striped mb-0"
            classContainer="table-responsive-xl"
          />
        </div>
      </div>

      <TenantFormModal
        showModal={showModal}
        isEditMode={isEditMode}
        initialData={formState}
        onClose={closeModal}
        onSubmit={handleSubmit}
      />

      <BaseModal
        modalTitle={modalTitle}
        showModal={modals.toggleTenantStatus || modals.deleteTenant}
        onClose={() => handleTenantAction("", selectedEntity as ITenant)}
        onCancel={() => handleTenantAction("", selectedEntity as ITenant)}
        onSave={handleConfirmTenantAction}
        successBtnText="Confirm"
        cancelActionBtnText="Cancel"
      />

      <ToastContainer />
    </div>
  );
};

export default TenantsManagementScreen;
